enum TriggerBonusType {
  SEGMENTATION_BONUS = 'SEGMENTATION_BONUS',
  DEPOSIT = 'DEPOSIT',
  ACTIVATE_ACCOUNT = 'ACTIVATE_ACCOUNT',
  ACCOUNT_VERIFICATION = 'ACCOUNT_VERIFICATION',
  BONUS_CODE = 'BONUS_CODE',
}

export default TriggerBonusType
